import { StyleSheet } from 'aphrodite';
import { headerHeight } from '../../../../../aida/styles/styles';
import {
	aceGray,
	background,
	black,
	brandPrimaryText,
	charmGray,
	darkGrayFontColor,
	destructive,
	destructiveHover,
	destructiveHoverLight,
	gray3,
	gray4,
	mentionDark,
	titles,
	white,
} from '../../../../styles/colors';
import { CssSelectors, ctaButtonBase } from '../../../../styles/styles';

export const styles = StyleSheet.create({
	// Layout styles
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		background,
	},
	flex: {
		display: 'flex',
		flex: 1,
	},
	leftContainer: {
		flex: 2,
		padding: 20,
		overflowY: 'auto',
		width: '100%',
	},
	rightContainer: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: 16,
		justifyContent: 'space-between',
		backgroundColor: white,
		maxWidth: 360,
	},
	footer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},

	// Preview container styles
	previewContainer: {
		width: 800,
		height: 600,
		margin: '25px auto',
		padding: '1rem',
		border: `1px solid ${aceGray}`,
		borderRadius: 8,
		backgroundColor: white,
		fontFamily: 'Arial, sans-serif',
		overflowY: 'auto',
	},
	previewContainerHeader: {
		alignItems: 'center',
		borderBottom: `1px solid ${mentionDark}`,
		boxSizing: 'border-box',
		color: brandPrimaryText,
		display: 'flex',
		fontSize: 24,
		height: headerHeight,
		paddingBottom: 5,
		paddingLeft: 30,
		justifyContent: 'space-between',
	},
	emailComposerFooter: {
		color: darkGrayFontColor,
		fontSize: 12,
		fontStyle: 'italic',
		letterSpacing: '0',
		lineHeight: '22px',
		whiteSpace: 'pre',
		margin: '0px auto',
		display: 'flex',
		width: 800,
	},
	subject: {
		color: titles,
		fontSize: 14,
		marginRight: 30,
		padding: '10px 5px',
	},
	composerTitle: {
		padding: '10px 5px',
		color: charmGray,
		fontSize: 14,
	},

	// Header and content styles
	header: {
		marginBottom: 12,
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
		color: black,
		marginBottom: 4,
	},
	subtitle: {
		fontSize: 14,
		color: gray4,
		marginBottom: 8,
	},
	divider: {
		border: 0,
		height: 1,
		backgroundColor: aceGray,
	},

	// Button styles
	ctaButton: {
		backgroundColor: brandPrimaryText,
		color: white,
		border: 'none',
		padding: '10px 20px',
		cursor: 'pointer',
		borderRadius: 4,
		':disabled': {
			backgroundColor: aceGray,
			cursor: 'not-allowed',
		},
	},
	rejectButton: {
		...ctaButtonBase,
		':active': {
			background: destructiveHover,
		},
		':hover': {
			background: destructiveHoverLight,
			border: `1px solid ${destructiveHover}`,
		},
		transition: 'color .5s, background-color .5s',
		background: white,
		border: `1px solid ${destructive}`,
		boxShadow: '0 1px 2px 0 #f9f9f9',
		color: destructive,
	},

	// Social media banner styles
	socialMediaBannerContainer: {
		background: '#E5FAFF',
		borderRadius: 3,
		display: 'flex',
		height: 40,
		maxWidth: 470,
		...CssSelectors.allChildren({
			alignItems: 'center',
			color: white,
			display: 'flex',
			fontSize: 14,
			justifyContent: 'space-between',
			paddingRight: 10,
		}),
	},
	bannerText: {
		paddingLeft: 10,
		color: brandPrimaryText,
	},

	// Citation modal styles
	citationModal: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		background: white,
		padding: 20,
		borderRadius: 10,
		boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
		width: 400,
	},
	citationContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		overflowY: 'auto',
		wordBreak: 'break-word',
		maxHeight: 400,
	},
	citationTitle: {
		fontSize: 18,
		fontWeight: 'bold',
		marginBottom: 10,
	},
	citationContent: {
		fontSize: 14,
		color: gray3,
		marginBottom: 20,
		textAlign: 'center',
	},
	modalOverlay: {
		alignItems: 'center',
		background: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		inset: 0,
		height: '100%',
		justifyContent: 'center',
		position: 'fixed',
		width: '100%',
		zIndex: 5,
	},

	// Rejection info styles
	rejectionInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		padding: '12px 0',
	},
	rejectionReasonSection: {
		marginBottom: 16,
	},
	rejectionReasonTitle: {
		fontSize: 15,
		color: gray3,
		marginBottom: 8,
	},
	rejectionCategoryList: {
		listStyleType: 'disc',
		paddingLeft: 20,
		margin: '4px 0',
	},
	rejectionCategoryItem: {
		color: gray4,
		fontSize: 14,
		marginBottom: 4,
	},
	rejectionNotesSection: {
		marginBottom: 8,
	},
	rejectionNotesTitle: {
		fontSize: 15,
		color: gray3,
		marginBottom: 8,
	},
	rejectionNotesContent: {
		fontSize: 14,
		color: gray4,
		whiteSpace: 'pre-line',
		lineHeight: 1.4,
	},
});
